import moment from 'moment';
import * as Dati from '../Dati';
import * as Glob from '../Globale';
import * as React from "react";
import { Tipo, Trad } from "./";
import { BasePureComponent } from './BaseComponent';

interface IPolizzaApprovazioneProps extends Dati.IBaseProps {
    Dati: Glob.DatiJSON;
    TipiPolizzaApprovazione: Dati.TDictTipo;
}

interface IPolizzaApprovazioneState {
    Dati: Dati.CPolizzaApprovazione[];
}

export class PolizzaApprovazione extends BasePureComponent<IPolizzaApprovazioneProps, IPolizzaApprovazioneState> {

    private Sessione = Glob.GetSessione();

    constructor(props: any) {
        super(props);

        this.state = { Dati: [] };

        this.OnAggiornaEvento = this.OnAggiornaEvento.bind(this);
        this.OnChange = this.OnChange.bind(this);
    }

    private OnAggiornaEvento(e: React.FormEvent<any>): void {
        let ID_AnagDa = e.currentTarget.getAttribute("data-idanagda");
        for (let D in this.state.Dati) {
            if (ID_AnagDa == this.state.Dati[D].ID_AnagDa.toString()) {
                this.OnChange("Dati[" + D + "]." + e.currentTarget.name, e.currentTarget.value);
                this.OnChange("Dati[" + D + "].Data", new Date(Date.now()));
            }
        }
        this.props.OnChange(this.props.Name, JSON.stringify(this.state.Dati));
    }

    private OnAggiornaCampo(campo: string, id_AnagDa: string, valore?: any): void {
        for (let D in this.state.Dati) {
            if (id_AnagDa == this.state.Dati[D].ID_AnagDa.toString()) {
                this.OnChange("Dati[" + D + "]." + campo, valore);
                this.OnChange("Dati[" + D + "].Data", new Date(Date.now()));
            }
        }
        this.props.OnChange(this.props.Name, JSON.stringify(this.state.Dati));
    }


    static getDerivedStateFromProps(props: IPolizzaApprovazioneProps, state: IPolizzaApprovazioneState): IPolizzaApprovazioneState {
        return { Dati: JSON.parse(props.Dati) };
    }

    private ListaCommentiGruppi(id_AnagDa: number, commentiGruppi: { [T: string]: string }): React.ReactNode[] {
        let R: React.ReactNode[] = [];

        let Sessione = Glob.GetSessione();

        for (let CG in commentiGruppi) {
            R.push(<div className="col-lg-12" key={CG}>
                <label>{Trad.Trad("Commenti")} {Trad.Trad("Gruppo" + CG)}</label>
                <div className="kt-input-icon kt-input-icon--right">
                    <textarea
                        data-idanagda={id_AnagDa}
                        className="form-control"
                        id="kt_autosize_1"
                        rows={3}
                        name={"CommentiGruppi[" + CG + "]"}
                        value={commentiGruppi[CG] || ""}
                        onChange={(e) => this.OnAggiornaEvento(e)}
                        disabled={this.Sessione.ID_Anag != id_AnagDa || Sessione.Gruppi.indexOf(CG) < 0} />
                </div>
            </div>);
        }
        return R;
    }

    public render() {
        if (this.state.Dati.length == 0) {
            return false;
        }
        else {
            return this.state.Dati.map((Dato, Indice) => {
                return <div key={Indice} className={this.props.Visibile != undefined && this.props.Visibile ? "form-group kt-form login-form__group row" : "hidden"}>
                    <div className="col-lg-12">
                        {Trad.Trad("ApprovazionePolizza")}
                    </div>
                    <div className="col-6">
                        <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" ID_Chiave={Dato.ID_AnagDa} Campo="ID_AnagDa" Disabilitato TradValori />
                    </div>
                    <div className="col-5">
                        <Tipo Dati={this.props.TipiPolizzaApprovazione} ID_ChiaveString={Dato.ID_TipoPolizzaApprovazione || Glob.Tipi_PA_Proposta} Campo="ID_TipoPolizzaApprovazione" Disabilitato={this.Sessione.ID_Anag != Dato.ID_AnagDa} TradValori OnAggiorna={(e, v) => this.OnAggiornaCampo("ID_TipoPolizzaApprovazione", Dato.ID_AnagDa.toString(), v)} />
                    </div>
                    <div className="col-1">
                        {moment(Dato.Data).format(Trad.Trad("DD/MM/YYYY"))}
                    </div>
                    {Glob.AzioneAbilitata("PolizzaApprovazioneCommenti", Glob.Lettura) &&
                        this.ListaCommentiGruppi(Dato.ID_AnagDa, Dato.CommentiGruppi)
                    }
                </div>
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/PolizzaApprovazione.tsx